import { useContext } from 'react';
import { DataDispatcherContext } from './DataContext';
import { TDataDispatcher } from './Types';

export function useDataDispatcher<T extends object = any>() {
  return useContext(DataDispatcherContext) as TDataDispatcher<T>;
}
